<p-sidebar [(visible)]="showDialog" position="right" [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'100em'}">
    <ng-template pTemplate="header">Reward 4W Xpress 50 Drivers</ng-template>

    <div class="reward-xpress50-header flex-row">
        <div>
            <div>Total riders count: {{totalRecords}}</div>
            <div>Riders for Reward count: {{getRidersForRewardCount()}}</div>
        </div>
        <div class="filler"></div>
        <div>
            <p-calendar [appendTo]="'body'"
                        [inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
                        (onSelect)="onChangeDate()" [(ngModel)]="selectedDate"
                        [readonlyInput]="false" [showIcon]="true"></p-calendar>
        </div>
    </div>
    <div>
        <!-- Table -->
        <p-table #ridersGrid
                 [columns]="cols"
                 [value]="riders"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 [showFirstLastIcon]="false"
                 [paginator]="false"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(100vh - 270px)'}">
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-driver>
                <tr class="cursor-pointer" (click)="driver.IsForReward = !driver.IsForReward">
                    <td class="ui-resizable-column">{{driver.RiderId}}</td>
                    <td class="ui-resizable-column">{{driver.FirstName}}</td>
                    <td class="ui-resizable-column">{{driver.LastName}}</td>
                    <td class="ui-resizable-column">{{driver.Phone}}</td>
                    <td class="ui-resizable-column">{{driver.AcceptanceRate}}</td>
                    <td class="ui-resizable-column">{{driver.CancellationRate}}</td>
                    <td class="ui-resizable-column">{{driver.CompleteRate}}</td>
                    <td class="ui-resizable-column">{{driver.CountTrips}}</td>
                    <td class="ui-resizable-column">{{driver.TotalActivity}}</td>
                    <td class="ui-resizable-column">&#8369;{{driver.XpressEarningAmount}}</td>
                    <td>
                        <p-checkbox [ngModel]="driver.IsForReward"
                                    [binary]="true" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div style="display: flex; justify-content: right; margin-top: 20px;">
        <button pButton pRipple type="button"
                label="Reward"
                (click)="rewardRxp4w50Drivers()"
                class="p-button-success"
                [disabled]="loading"></button>
    </div>

    <p-dialog [(visible)]="showErrorDialog"
              [modal]="true"
              [style]="{ width: '40vw' }"
              [draggable]="false"
              [resizable]="false"
              [closable]="true"
              (onHide)="handleHideErrorDialog()">
        <ng-template pTemplate="item">
            <div class="modal-content-center">
                <h1>Failed Drivers:</h1>
            </div>
            <div class="modal-content-center">
                <p-scrollPanel [style]="{ width: '100%', height: '400px' }">
                    <p *ngFor="let item of failedRiders">
                        Rider Id: {{item.RiderId}}. Reason: {{item.Reason}}
                    </p>
                </p-scrollPanel>
            </div>
        </ng-template>
    </p-dialog>

</p-sidebar>
